import { useEffect, useState,useContext  } from "react";
import $ from "jquery";
import {
    useNavigate
  } from "react-router-dom";
  import {Card,ListGroup} from 'react-bootstrap';
  import Spinner from 'react-bootstrap/Spinner';
  import Alert from 'react-bootstrap/Alert';
  import UserContext from "../../contexts/UserContext";

const RsvpCount = () => {
    const navigate = useNavigate(); 

    const [isLoading, setLoading] = useState(true);
    const [rsvpData,setRsvpData] = useState([]);
    const {user,setUser} = useContext(UserContext);

    async function getUser(userId){
        await $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success :async function(response){
            if(response && response.user){
              setUser(response.user);
              if(!(response.user.role==='admin')){
                setLoading(false);
              }
            }else{
              setUser(null);
              navigate("/login",{state: { message: response.message }})
            }
      
          },
          error: function(err){
              console.log("error")
              console.log(err)
              setLoading(false);
          }
      })
      }
      
      function getData(){
          $.ajax({
              type:"GET",
              url:process.env.REACT_APP_API_URL+"/rsvpCounts",
              xhrFields: {
                  withCredentials: true  // Include cookies
                },
                crossDomain: true, 
               success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                  navigate("/login",{state: { message: response.message }});
                }
                setRsvpData(response);
                setLoading(false);
              },
              error: function(err){
                  console.log("error")
                  console.log(err)
                  setLoading(false);
              }
          })
      }
      
      useEffect(() => {
        if (user && (user.role === 'admin' || user.role === 'fmbmember')) {
          getData();
        }else{
          try{
          if(!user && localStorage.getItem('userSession')){
            getUser(JSON.parse(localStorage.getItem('userSession')))
          }else{
            if(!user){
              navigate("/login")
            }
          }
        }catch(e){
          if(!user){
            navigate("/login")
          }
        }
          navigate("/home")
        }
      }, [user]);
    const design = (
        <>
            <>
                {
                rsvpData && rsvpData.length>0?rsvpData.map((day,i)=>{
                    return <Card key={i} className="m-2 mb-4 mx-3">
                        <Card.Header>{day.date}</Card.Header>
                        <ListGroup variant="flush">
                            {
                                day.rsvp.map((items,i)=>{
                                    return !items.name.label?<div key={i}>
                                    <ListGroup.Item>{items.name}</ListGroup.Item>
                                    <ListGroup.Item>Estimated Dabba Count : {items.value}</ListGroup.Item></div>:null
                                })
                            }
                        </ListGroup>
                        </Card>
                }):<Alert key='danger' variant='danger'>The Dashboard will open once the menu is updated for next week !</Alert>
                }
            </>
        </>
    )
    return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
    </Spinner><br/>
    <span style={{marginLeft:'-10px'}}>Loading...</span></div>:design;
};

export default RsvpCount;